import { Injectable, signal } from '@angular/core';

import {
    LDProductSegmentationKey,
    LDProductSegmentationVariantMap,
    LaunchDarklyShowRGKey,
    ManageLobbyContainerLDFlags,
} from './manage-lobby-container.model';

@Injectable({ providedIn: 'root' })
export class ManageLobbyContainerService {
    readonly madeForYouSubcategoryID = 'LMC_MADEFORYOU';

    readonly initialMadeForYouContainerPosition = -2;

    madeForYouContainerPosition = signal<number>(this.initialMadeForYouContainerPosition);

    activeLDFLag = signal<string>('');
    servedLDVariant = signal<string>('');

    manageSubcategory(subcategories: any): any {
        const ldFlag = this.activeLDFLag();
        if (!subcategories || !ManageLobbyContainerLDFlags.includes(ldFlag)) {
            return subcategories;
        }
        if (ldFlag === LaunchDarklyShowRGKey) {
            return this.getAdjustedMadeForYouSubcategory(subcategories);
        } else if (ldFlag === LDProductSegmentationKey) {
            return this.filterSubcategories(subcategories);
        }
        return subcategories;
    }

    private getAdjustedMadeForYouSubcategory(subcategories: any): any {
        const currentIndex = this.getMadeForYouSubcategoryIndex(subcategories);
        const currentPosition = this.madeForYouContainerPosition();
        if (currentIndex === -1 || currentPosition === this.initialMadeForYouContainerPosition) {
            return subcategories;
        }
        return this.adjustMadeForYouSubcategoryPosition(subcategories, currentIndex, currentPosition);
    }

    private getMadeForYouSubcategoryIndex(subcategories: any): number {
        return subcategories.findIndex((subcategory: any) => {
            if (subcategory?.categoryInfo) {
                return subcategory.categoryInfo?.subcategoryid === this.madeForYouSubcategoryID;
            }
            return subcategory?.subcategoryid === this.madeForYouSubcategoryID;
        });
    }

    private adjustMadeForYouSubcategoryPosition(
        subcategories: any,
        currentMadeForYouContainerIndex: number,
        expectedMadeForYouContainerPosition: number,
    ): any[] {
        if (expectedMadeForYouContainerPosition === 0 || expectedMadeForYouContainerPosition >= subcategories.length) {
            return subcategories;
        }
        const updatedSubcategories = [
            ...subcategories.slice(0, currentMadeForYouContainerIndex),
            ...subcategories.slice(currentMadeForYouContainerIndex + 1),
        ];
        if (expectedMadeForYouContainerPosition !== -1) {
            updatedSubcategories.splice(expectedMadeForYouContainerPosition, 0, subcategories[currentMadeForYouContainerIndex]);
        }
        return updatedSubcategories;
    }

    private filterSubcategories(subcategories: any): any {
        const servedVariant = this.servedLDVariant();
        const idsToExclude = new Set<string>();
        LDProductSegmentationVariantMap.forEach((ids, variant) => {
            if (variant !== servedVariant) {
                ids.forEach((subcategoryId: string) => idsToExclude.add(subcategoryId));
            }
        });
        return subcategories.filter((sub: any) => {
            if (sub?.categoryInfo) {
                return !idsToExclude.has(sub.categoryInfo.subcategoryid);
            }
            return !idsToExclude.has(sub.subcategoryId);
        });
    }
}
